<template>
  <v-container>
    <div class="elevation-2 px-5 mt-3">
      <SimplePageHeader title="Email Library Assets" class="px-4 pr-5 mb-5">
        <template v-slot:right-buttons>
          <ButtonCustomIcon
            icon="add"
            color="primary"
            text="Add"
            :block="true"
            @click="openUploadDialog"
          />
        </template>
      </SimplePageHeader>
      <v-row class="px-5 pb-2" align="center">
        <v-col cols="12" sm="6" class="pb-0">
          <v-text-field
            v-model="filterName"
            label="Name"
            clearable
            outlined
          />
        </v-col>
        <v-col cols="12" sm="6" class="pb-0">
          <v-switch
            v-model="filterIsActive"
            :label="filterIsActive ? 'Active' : 'Inactive'"
            class="mt-0"
            @change="loadAssets"
          />
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-col cols="12" md="6">
          <FilterButtons
            @search="loadAssets"
            @clear="handleClearClick"
          ></FilterButtons>
        </v-col>
      </v-row>
      <FilterButtonsSmall
        @search="loadAssets"
        @clear="handleClearClick"
      ></FilterButtonsSmall>
    </div>
    <v-container fluid class="px-0 pt-2 mt-4">
      <v-layout column>
        <v-data-table
          dense
          :headers="headers"
          :items="workflowLibraryAssetList"
          class="elevation-2"
        >
          <template v-slot:item.isActive="{ item }">
            <v-simple-checkbox
              v-model="item.isActive"
              disabled
            />
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              class="mx-1 my-1"
              color="primary"
              outlined
              @click="openEditDialog(item)"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-layout>
    </v-container>

    <WorkflowLibraryAssetUploadDialog
      v-if="showDialog"
      :asset="selectedAsset"
      @close="showDialog = false"
      @saved="handleSaved"
    />

    <BottomSpacer />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { SimplePageHeader } from '@/components/pageComponents'
import { BottomSpacer, ButtonCustomIcon, FilterButtons, FilterButtonsSmall } from '@/components/buttons'
import WorkflowLibraryAssetUploadDialog from './WorkflowLibraryAssetUploadDialog'

export default {
  components: {
    SimplePageHeader,
    BottomSpacer,
    WorkflowLibraryAssetUploadDialog,
    ButtonCustomIcon,
    FilterButtons,
    FilterButtonsSmall
  },
  data () {
    return {
      filterName: null,
      filterIsActive: true,
      showDialog: false,
      selectedAsset: null,
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'File Name', value: 'fileName', sortable: true },
        { text: 'Content Type', value: 'contentType', sortable: true, width: '20%' },
        { text: 'Active', value: 'isActive', align: 'center', sortable: false, width: '10%' },
        { text: 'Actions', value: 'action', align: 'center', sortable: false, width: '10%' }
      ]
    }
  },
  computed: {
    ...mapFields('workflowLibraryAssets', ['workflowLibraryAssetList'])
  },
  methods: {
    ...mapActions('workflowLibraryAssets', ['getWorkflowLibraryAssets']),
    loadAssets () {
      const filters = { isActive: this.filterIsActive }
      if (this.filterName) filters.name = this.filterName
      this.getWorkflowLibraryAssets(filters)
    },
    openUploadDialog () {
      this.selectedAsset = null
      this.showDialog = true
    },
    openEditDialog (asset) {
      this.selectedAsset = asset
      this.showDialog = true
    },
    handleSaved () {
      this.showDialog = false
      this.loadAssets()
    },
    handleClearClick () {
      this.filterName = null
      this.filterIsActive = true
      this.loadAssets()
    }
  },
  created () {
    this.loadAssets()
  }
}
</script>
